<template>
  <div class="doors">
    <div v-if="doors.length > 0" class="doors__header">
      <v-icon color="primary" class="doors__header-icon">mdi-door-open</v-icon>
      <h2 class="doors__title">Двери</h2>
    </div>
    <v-card flat class="doors__card mt-4" v-if="doors.length > 0">
      <v-row>
        <v-col cols="12">
          <v-data-table
            class="table"
            :headers="displayTable"
            :items="displayData"
          >
            <template v-slot:item.name="{ item }">
              <v-text-field
                outlined
                dense
                hide-details
                flat
                :disabled="isDisabledRoleNameMaster"
                v-model="item.name"
                :rules="[
                  () => !!item.name || 'Обязательное поле',
                ]"
              ></v-text-field>
            </template>
            <template v-slot:item.isActive="{ item }">
              <div>
                <v-checkbox
                  v-model='item.is_active'
                  class='mt-4'
                  type="checkbox"
                  label="Отображение"
                  :disabled="isDisabledRoleNameMaster"
                >
                </v-checkbox>
              </div>
            </template>
            <template v-slot:item.doorOpen="{ item }">
              <div>
                <v-checkbox
                  v-model='item.door_open_mode'
                  class='mt-4'
                  type="checkbox"
                  :disabled="isDisabledDoorOpen || item.door_open_mode === null"
                  @click="getInfoDoorNum(item)"
                  @change="handleCheckboxChange($event, item.doornum)"
                  :label="displayOpenDoor(item.door_open_mode)"
                >
                </v-checkbox>
              </div>
            </template>
            <template v-slot:item.separate="{ item }">
              <div>
                <v-checkbox
                  v-model='item.separate'
                  class='mt-4'
                  type="checkbox"
                  label="Отдельно в приложении"
                  :disabled="isDisabledRoleNameMaster"
                >
                </v-checkbox>
              </div>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                color="primary"
                class="text-none"
                rounded
                @click="save(item)"
              >
                <v-icon left small>mdi-content-save-outline</v-icon>
                Сохранить
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { headersDoors, headersDoorsRubetek3438, SEPARATE_OPEN_DOOR } from '../consts';

export default {
  name: 'Doors',
  data: () => ({
    doors: [],
    infoDoorOpen: [],
    jointDataDoors: [],
    doornum: null,
    isDisabledRoleNameMaster: false,
    isDisabledDoorOpen: false,
    include: ['childDoorphones,parentDoorphones'],
    headersDoors,
    headersDoorsRubetek3438,
  }),
  computed: {
    ...mapGetters({
      doorphoneEditInfo: 'Doorphone/doorphoneEditInfo',
      roleName: 'roleName',
    }),
    displayTable (item) {
      if (item.doorphoneEditInfo.doorphone.model === 'RV-3434') {
        return this.headersDoors;
      }
      if (item.doorphoneEditInfo.doorphone.manufacturer === 'Beward') {
        return this.headersDoors;
      } else {
        return this.headersDoorsRubetek3438;
      }
    },
    displayData (item) {
      if (item.doorphoneEditInfo.doorphone.model === 'RV-3434') {
        return this.jointDataDoors;
      }
      if (item.doorphoneEditInfo.doorphone.manufacturer === 'Beward') {
        return this.jointDataDoors;
      } else {
        return this.doors;
      }
    },
    checkRequest (item) {
      return item.doorphoneEditInfo.doorphone.model !== 'RV-3438';
    },
  },
  methods: {
    ...mapActions({
      getDoors: 'Door/getDoors',
      updateDoor: 'Door/updateDoor',
      getInfoDoorOpen: 'Door/getInfoDoorOpen',
      editDoorOpenMod: 'Door/editDoorOpenMod',
    }),
    displayOpenDoor (item) {
      return SEPARATE_OPEN_DOOR[item];
    },
    getInfoDoorNum (item) {
      this.doornum = item.doornum;
    },
    handleCheckboxChange (event, index) {
      if (this.checkRequest) {
        this.$set(this.doors, index, { ...this.doors[index], changed: true });
      }
    },
    saveDoorOpen (item) {
      this.doors.forEach((door, index) => {
        if (door.changed && door.door_open_mode !== false && this.checkRequest) {
          this.doorOpenModes(item.doornum, item.door_open_mode);
          this.$set(this.doors, index, { ...door, changed: false });
        }
      });
    },
    save (item) {
      if (this.roleName === 'master') {
        this.saveDoorOpen(item);
      }
      this.updateDoor({
        id: this.$route.params.id,
        doornum: item.doornum,
        name: item.name,
        separate: item.separate,
        is_active: item.is_active,
      })
        .then(() => {
          this.saveDoorOpen(item);
          this.$flash_success('Изменения успешно сохранены');
        })
        .catch(() => {
          this.$flash_warning('Ошибка сохранения');
        });
    },
    doorOpenModes (doornum, doorOpenMode) {
      if (doorOpenMode !== null) {
        this.editDoorOpenMod({
          id: this.$route.params.id,
          num: doornum,
          doorOpen: doorOpenMode,
        })
          .then(() => {
            if (doorOpenMode) {
              this.$flash_success('Дверь держаться открытой');
            } else {
              this.$flash_success('Дверь закрыта');
            }
          })
          .catch(() => {
            this.getData();
            this.$flash_warning('Ошибка сохранения настроек "Держание двери открытой"');
          });
      }
    },
    gettingDoorOpenSettings () {
      this.getInfoDoorOpen(this.$route.params.id)
        .then(doors => {
          this.infoDoorOpen = doors;
          let doorOpenMode = [];
          if (this.infoDoorOpen.door_open_mode_3 === false || this.infoDoorOpen.door_open_mode_3 === true) {
            doorOpenMode = [
              { door_open_mode: this.infoDoorOpen.door_open_mode_1 },
              { door_open_mode: this.infoDoorOpen.door_open_mode_2 },
              { door_open_mode: this.infoDoorOpen.door_open_mode_3 },
            ];
          } else {
            doorOpenMode = [
              { door_open_mode: this.infoDoorOpen.door_open_mode_1 },
              { door_open_mode: this.infoDoorOpen.door_open_mode_2 },
              { door_open_mode: null },
            ];
          }
          this.jointDataDoors = this.doors.map((item, index) => ({ ...item, ...doorOpenMode[index] }));
        })
        .catch((err) => {
          console.error(err);
          this.isDisabledDoorOpen = true;
          this.jointDataDoors = this.doors;
          if (err.response && err.response.status === 400) {
            const error = err.response.data.error;
            this.$flash_warning('Ошибка: ' + error);
          } else {
            this.$flash_warning('Не удалось получить настройки открытия дверей');
          }
        });
    },
    getData () {
      this.getDoors(this.$route.params.id)
        .then(doors => {
          this.doors = doors;
          if (this.checkRequest) {
            this.gettingDoorOpenSettings();
          }
        })
        .catch((err) => {
          console.error(err);
          if (err.response && err.response.status === 400) {
            const error = err.response.data.error;
            this.$flash_warning('Ошибка: ' + error);
          } else {
            this.$flash_warning('Не удалось получить настройки дверей');
          }
        });
    },
  },
  created () {
    this.getData();
    switch (this.roleName) {
      case 'master':
        this.isDisabledRoleNameMaster = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.doors__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.doors__header-icon {
  flex-shrink: 0;
}

.doors__title {
  font-size: 1.25rem;
  font-weight: 500;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.01em;
}
</style>
